module.exports = __webpack_public_path__ + "img/tab-calibration.20e1d0e2.png";